<template>
  <el-dialog
    :visible.sync="showApplyDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="title"
    :width="step ? '430px' : '860px' "
    :before-close="doCancel"
    custom-class="mould-dialog"
  >
    <el-form
        v-if="step === 1"
        ref="mouldForm"
        label-width="100px"
        label-position="left"
        :model="applyInfo"
        :rules="rules"
    >
        <el-form-item label="印模类型：">
            {{ mouldInfo.mouldName }}
        </el-form-item>
        <el-form-item label="印模图片：">
            <div class="mould-perview clearfix">
            <img :src="mouldImg" class="mould-img" />
                <el-upload
                    action=""
                    ref="upload"
                    class="upload-btn"
                    id="upload"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="reUpload"
                >
                    <el-button size="mini" type="primary">重新上传</el-button>
                </el-upload>
            </div>
        </el-form-item>
        <el-form-item label="姓名："  prop="operator">
          <el-input v-model="applyInfo.operator" placeholder="请输入经办人姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="operatorCardNo">
          <el-input v-model="applyInfo.operatorCardNo" placeholder="请输入经办人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="operatorContact">
          <el-input v-model="applyInfo.operatorContact" placeholder="请输入经办人手机号"></el-input>
        </el-form-item>
        <el-form-item label="法人名称："  prop="legalPerson" v-if="!isSHCompany">
          <el-input v-model="applyInfo.legalPerson" placeholder="请输入法人名称"></el-input>
        </el-form-item>
        <el-form-item label="公司名称：" prop="companyName" v-if="!isSHCompany">
          <el-input v-model="applyInfo.companyName" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="申请承诺书：" v-if="!isMouldrecord">
            <div>请先下载打印承诺书模板并加盖公章，完成后重新扫描上传，提交审核</div>
            <a class="blue-text"
                href="/qyswebapp/assets/js/vendor/promise.pdf"
                download="上海市电子印章公共服务平台《企业印模申请承诺书》.pdf">模板下载：申请承诺书 </a>
            <el-upload
              class="mouldFile-upload"
              ref="uploadFile"
              action=""
              :show-file-list="false"
              :on-change="uploadMouldFile"
            >
                <p v-if="this.fileName"> {{fileName}}</p>
                <p v-else>上传加盖公章后的承诺书(小于10M)</p>
            </el-upload>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" v-if="step === 1">
        <el-button type="default" @click="doCancel">取消</el-button>
        <el-button type="primary" @click="doApply">提交申请</el-button>
    </span>

    <!-- 裁剪 -->
    <croper
        v-if="step === 0"
        :img-url="mouldImg"
        seal-type="normal"
        data-type="base64"
        :specs="sealOptions"
        show-example.sync="false"
        @onSaveImage="doSaveImage"
        @onCancel="doCancel"></croper>

    <PreviewSeal
        v-if="step === -1"
        :img-url="mouldImg"
        :img-size="imgSize"
        @changeStep="step = 0"
        @directlyUpload="doSaveImage"
        @onCancel="doCancel"
    />
    <!-- ukey签署 -->
    <ukey-password-confirm :visible.sync="visibleUkey"
        v-if="visibleUkey"
        confirm-text="确定"
        @onConfirm="doUkeyMouldApply"></ukey-password-confirm>
    <el-dialog
        v-if="qrImage"
        width="40%"
        custom-class="qr-dialog"
        :before-close="doCancelQr"
        :visible="true"
        append-to-body>
        <div>
            <p  class="qr-tip">请使用【“随申办”APP / 微信或支付宝电子营业执照小程序】扫码确认</p>
            <div class="qr-content">
                <img class="qr-img"  :src="`data:image/png;base64,${qrImage}`" />
                <div  class="expire-img clearfix" v-if="isExpire">
                    <p class="expire-tips">二维码已过期请刷新后重试</p>
                    <el-button @click="doRefresh" size="mini" type="primary" :loading="isLoading">刷新</el-button>
                </div>
            </div>
            <p class="expire-time">过期时间： {{ time }}</p>
        </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import qs from 'qs';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import Croper from '../../components/croper/index.vue';
import UkeyPasswordConfirm from '../sign/childs/ukey-password-confirm.vue';
import PreviewSeal from './preview-seal.vue';

export default {
    components: { Croper, UkeyPasswordConfirm, PreviewSeal},
    props: {
        showApplyDialog: Boolean,
        mouldImg: String,
        mouldInfo: Object,
        imgSize: Number,
    },
    data() {
        return {
            applyInfo: {},
            step: -1, //-1 印章预览，0 裁剪页， 1 申请信息填写页
            fileName: '',
            isSHCompany: false,
            isMouldrecord: false,
            visibleUkey: false,
            isLoading: false,
            // 印章规格
            sealOptions: [
                {
                    height: 42,
                    key: 'CIRCULAR_42',
                    label: '圆形（直径42mm）',
                    type: 'CIRCULAR',
                    width: 42
                }
            ],
            time: 60,
            loopTimer: '',
            rules: {
                operator: [{ required: true, message: '请输入经办人姓名', triggle: 'blur' }],
                legalPerson: [{ required: true, message: '请输入法人名称', triggle: 'blur' }],
                companyName: [{ required: true, message: '请输入公司名称', triggle: 'blur' }],
                operatorCardNo: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('请输入经办人身份证号'));
                        } else {
                            const local_reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
                            const macou_reg = /^[1|5|7]\d{6}[(\d)]{3}$/;
                            const taiwan_reg = /^[a-zA-Z][0-9]{9}$/;
                            const hk_reg = /^[a-zA-Z]\d{6}\([\dA]\)$/;
                            // 内陆以及港澳台地区身份证号码校验
                            if (!(local_reg.test(value) || macou_reg.test(value) || taiwan_reg.test(value) || hk_reg.test(value))) {
                                callback(new Error('身份证号格式不正确'));
                            }
                        }
                        callback();
                    },
                    triggle: 'blur',
                }],
                operatorContact: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('经办人手机号不能为空'));
                        } else {
                            var reg = /^(\+86|86)?1[0-9]{10}$/;
                            if (!reg.test(value)) {
                                callback(new Error('手机号格式不正确'));
                            }
                        }
                        callback();
                    },
                    triggle: 'blur'
                }],
            },
            qrImage: '',
            source: null,
        };
    },
    inject: ['app'],
    mounted() {
        this.querySHCompany();
        this.queryMouldRecord();
    },
    watch: {
        mouldInfo: {
            handler (nv) {
                this.applyInfo = _.pick(nv, ['operator', 'operatorCardNo', 'operatorContact']);
            },
            immediate: true,
            deep: true
        }
    },

    computed: {
        ...mapGetters(['isEtl']),
        title(){
            if(this.step === -1){
                return '印章预览';
            }else if(this.step !== 0){
                return '申请信息填写';
            }else{
                return '';
            }
        },
        isExpire() {
            return this.time === 0;
        }
    },
    methods: {
        descTime() {
            clearInterval(this.loopTimer);
            this.loopTimer = setInterval(() => {
                if (this.time) {
                    this.time--;
                } else {
                    this.source && this.source.cancel();
                }
            }, 1000);
        },
        doRefresh() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            if(this.loopTimer) {
                clearInterval(this.loopTimer);
            }
            this.doEtlMouldApply();

        },
        // 保存裁剪的图片
        async doSaveImage () {
            let imgBase64 = arguments[1] || '';
            this.$emit('update:mouldImg', imgBase64);
            this.step = 1;
        },
        reUpload(file) {
            this.$emit('handleChange', file);
            this.step = -1;
        },
        // 取消
        doCancel () {
            this.$emit('update:showApplyDialog', false);
        },
        uploadMouldFile(file) {
            let type = file.name.split('.')[1].toUpperCase();

            if (type !== 'PDF') {
                this.$message.error('文件仅支持pdf格式！');
                this.$refs.uploadFile.clearFiles();
                return;
            }
            this.fileName = file.name;
            this.$set(this.applyInfo, 'file', file.raw);
        },
        // 是否是上海公司
        async querySHCompany() {
            try {
                let resp = await this.axios({
                    url: '/seal/mould/isshanghai',
                    method: 'GET',
                });
                const { data: { isShanghai, code, message } } = resp;
                if(code === 0) {
                    this.isSHCompany = isShanghai;
                } else {
                    this.$message.error(message);
                }
            } catch (error) {
                console.log(error);
            }
        },

        getApplyParams() {
            const params = {
                ...this.applyInfo,
                sealType: this.mouldInfo.mouldType,
                picData: this.mouldImg.split(',')[1],
            };
            let requsetData = new FormData();
            for (let key in params) {
                requsetData.append(key, params[key]);
            }
            return requsetData;
        },

        // UKEY用户 获取签名数据摘要
        getUkeyDigest() {
            const params = this.getApplyParams();
            return this.axios({
                url: '/seal/mould/ukey/digest',
                method: 'POST',
                data: params,
            });
        },
        async doApply() {
            try {
                await this.$refs.mouldForm.validate();

                if(!this.isMouldrecord && !this.applyInfo.file) {
                    this.$message.error("请上传承诺书");
                    return;
                }

                if(this.isEtl) {
                    this.doEtlMouldApply();
                } else {
                    this.visibleUkey = true;
                }
            } catch (error) {
                console.log(error);
            }

        },
        // 电照登录用户申请逻辑
        async doEtlMouldApply() {
            try {

                if(this.source) {
                    this.source.cancel();
                }

                const params = this.getApplyParams();

                const resp = await this.axios({
                    url: '/seal/mould/etl/createapply',
                    method: 'POST',
                    data: params,
                });
                const { data: { code, token, qrimage, message }} = resp;
                if(code === 0) {
                    this.descTime();

                    this.qrImage = qrimage;
                    this.doEtlDigestsign(token);
                    this.time = 60;
                    this.isLoading = false;
                } else {
                    this.$message.error(message);
                }
            } catch (error) {
                console.log(error);
            }
        },

        // 电照用户获取签名
        async doEtlDigestsign(token) {
            try {
                const CancelToken = this.axios.CancelToken;
                this.source = CancelToken.source();

                const resp = await this.axios({
                    url: '/seal/mould/etl/digestsign',
                    method: 'POST',
                    data: qs.stringify({token}),
                    cancelToken: this.source.token
                });
                const { data: { code, message }} = resp;
                if(code === 0) {
                    this.$emit('initMould');
                    this.doCancel();
                    this.$message.success('申请成功');
                } else {
                    this.$message.error(message);
                }
                this.source = null;
                this.qrImage = '';
            } catch (error) {
                console.log(error);
            }
        },

        async doUkeyMouldApply(pin) {
            try {
                // 获取摘要
                const digestData = await this.getUkeyDigest();
                const { data: { code, id, digist, message }} = digestData;
                if(code) {
                    this.$message.error(message);
                    this.doCancel();
                    return;
                }
                // 签名
                let params = {
                    id,
                    rsaCert: this.app.cert
                };
                const resp = await this.app.ukey.sign(
                    {
                        data: digist,
                        pwd: pin
                    }
                );
                params.signedData = resp.result;
                // 申请印模
                let applyResp = await this.applyMoulage(params);
                applyResp = applyResp.data;

                if(applyResp.code === 0) {
                    this.$emit('initMould');
                    this.$message.success('申请成功');
                } else {
                    this.$message.error(applyResp.message);
                }
                this.doCancel();

            } catch (error) {
                this.doCancel();
                console.log(error);
            }

        },
        doCancelQr() {
            if(this.source) {
                this.source.cancel();
            }
            this.qrImage = ''
        },
        // Ukey申请印模
        applyMoulage(params) {
            return  this.axios({
                url: '/seal/mould/ukey/apply',
                method: 'POST',
                data: qs.stringify(params)
            });
        },
        // 公安是否备案
        async queryMouldRecord() {
            try {
                const resp = await this.axios({
                    url: '/seal/mould/record',
                    method: 'GET',
                    params: { sealType: this.mouldInfo.mouldType }
                });
                const { data: { isMouldrecord, code, message } } = resp;
                if(code === 0) {
                    this.isMouldrecord = isMouldrecord;
                } else {
                    this.$message.error(message);
                }
            } catch (error) {
                console.log(error);
            }

        }
    },
};
</script>

<style lang="less">
.mould-perview {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 288px;
    height: 152px;
    background-color: #F7F8F8 ;
    .mould-img {
        width: 120px;
    }
    .upload-btn {
        position: absolute;
        right: 0;
        top: 0;
    }
}
.qr-dialog {
    text-align: center;
    .qr-tip {
        margin-bottom: 10px;
    }
    .expire-tips {
        margin: 25px;
    }
    .qr-content {
        position: relative;
        margin: 0 auto;
        width: 147px;
        color: @white;
    }
    .expire-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;
    }
    .expire-time {
        color: @red;
    }
}
.mould-dialog {
    .mouldFile-upload {
        text-align: center;
        background-color: #F7F8F8 ;
    }
  .el-dialog__body {
    padding-top: 10px;
  }
}
</style>
